export const WITHOUT_MATERIAL = 19
